const MODULE_NAME = 'PATIENTS';
const INACTIVE_PATIENT_COMPLETED = MODULE_NAME + 'INACTIVE_PATIENT_COMPLETED';
const DELETE_COMPLETED = MODULE_NAME + 'DELETE_COMPLETED';
const SET_PATIENTS_QUERY = MODULE_NAME + 'SET_QUERY';

export {
  DELETE_COMPLETED,
  INACTIVE_PATIENT_COMPLETED,
  SET_PATIENTS_QUERY
};
